<!-- future updates - combine details with Overtime.vue component - use only one -->
<template>
  <v-form @submit.prevent="addEditOvertime" ref="form">
    <v-card dense style="border-radius:4px;">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold ">{{overtimeContext.mode}} Overtime</span>
            <v-spacer></v-spacer>
            <help-link appId="attendance" pageId="overtime-page" color="black"></help-link>
            <v-btn icon @click.native="closeDialog" :disabled="disabled">
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text >
            <v-alert v-if="overtimeContext.status==commonfn.getStatusCode('Approved')" :value="true" color="warning" icon="warning" outline style="margin:0px 20px 0px 20px;">
                This is already approved. Clicking Save will update back to For Review.
            </v-alert>  
            <p v-if="error" style="color:red;">{{ errorMessage }}</p>    
            <v-layout row>
                <v-flex xs12 sm12 style="padding:5px 25px 0px 25px;" >   
                    <v-layout row>  
                        <v-flex xs12 sm12 style="margin-top:-20px;">
                            <v-menu v-model="menuTransDate" :close-on-content-click="false" :nudge-right="40"
                                lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="transDate" label="Date" readonly v-on="on" :rules="[rules.required]" :disabled="disabled"></v-text-field>
                                </template>
                                <v-date-picker no-title v-model="transDate" :allowed-dates="allowedDates" @input="menuTransDate=false"></v-date-picker>
                            </v-menu>
                        </v-flex>      
                    </v-layout>        
                    <v-layout row>
                        <v-flex xs12 sm12 style="margin-top:-10px;">
                            <v-select
                                label="Project"
                                :items="project_list"
                                :rules="[rules.required]" 
                                item-text="projectDescription"
                                item-value="projectId"
                                :disabled="disabled"
                                v-model="overtimeContext.projectId"                
                                @change="setProjectTasks"  
                            ></v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs12 sm12 style="margin-top:-10px;">
                            <v-select
                                label="Task"
                                :items="projecttask_list"
                                :rules="[rules.required]" 
                                item-text="taskName"
                                item-value="projectTaskId"
                                :disabled="disabled"
                                v-model="overtimeContext.projectTaskId"                  
                            ></v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs12 sm12 style="margin-top:-5px;">
                           <!--Clock start-->
                            <div style="margin-top:-10px;">
                                <v-menu
                                    ref="menuClockStart"
                                    v-model="menuClockStart"
                                    :close-on-content-click="false"
                                    :return-value.sync="timeClockStart"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width

                                >
                                    <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="timeClockStart"
                                        label="Start Time"
                                        readonly
                                        v-on="on"
                                        :rules="[rules.required]" 
                                        @blur="computeTotalHours"
                                        @change="computeTotalHours"
                                    ></v-text-field>
                                    </template>
                                    <v-time-picker
                                    v-if="menuClockStart"
                                    v-model="timeClockStart"
                                    full-width
                                    :landscape="isMobile?false:true"
                                    @click:minute="$refs.menuClockStart.save(timeClockStart)"
                                    ></v-time-picker>
                                </v-menu>
                            </div>
                            <!--end: Clock start-->
                        </v-flex>
                    </v-layout> 
                    <v-layout row>
                        <v-flex xs12 sm12 style="margin-top:-10px;">
                            <!--Clock End-->               
                            <div style="margin-top:-10px;">
                                <v-menu
                                    ref="menuClockEnd"
                                    v-model="menuClockEnd"
                                    :close-on-content-click="false"
                                    :return-value.sync="timeClockEnd"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="timeClockEnd"
                                        label="End Time"
                                        readonly
                                        v-on="on"
                                        :rules="[rules.required]" 
                                        @blur="computeTotalHours"
                                        @change="computeTotalHours"
                                    ></v-text-field>
                                    </template>
                                    <v-time-picker
                                    v-if="menuClockEnd"
                                    v-model="timeClockEnd"
                                    full-width
                                    :landscape="isMobile?false:true"
                                    @click:minute="$refs.menuClockEnd.save(timeClockEnd)"
                                    ></v-time-picker>
                                </v-menu>
                            </div>               
                            <!--end: Clock End-->
                        </v-flex>
                    </v-layout>
                    <v-layout row style="margin-top:-10px">   
                        <v-flex xs12 sm6 style="margin-right:10px">
                            <v-select
                                label="Charging"
                                :items="offsetOrPay_list"
                                :rules="[rules.required]" 
                                item-text="Description"
                                item-value="offsetOrPay"
                                :disabled="disabled"
                                v-model="overtimeContext.offsetOrPay"                  
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6 style="margin-left:10px">
                            <v-text-field label="Break time (in minutes)" 
                                v-model="overtimeContext.breakTime" 
                                :rules="[rules.required]" 
                                type="number"
                                mask="###"
                                @blur="computeTotalHours"
                            ></v-text-field>
                        </v-flex>      
                    </v-layout>
                    <v-layout row>
                        <v-flex xs6 style="margin-right:10px">
                            Total Hours: <b>{{totalHours}}</b>
                        </v-flex>
                        <v-flex xs6 style="margin-left:10px">
                            Chargeable Hours: <b>{{chargeableHours}}</b>
                        </v-flex>
                    </v-layout>
                    <v-layout row style="margin:15px 0px -25px 0px;" v-show="overtimeContext.mode=='Add'">  
                        <v-flex xs12>
                            <v-textarea v-model="overtimeContext.remarks" 
                            :rules="[rules.required]"  
                            maxlength="150"
                            hint="150 characters max"
                            outline label="Comments" rows="1" color="primary" @click="computeTotalHours"></v-textarea>
                        </v-flex>      
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card-text>  
        <v-divider></v-divider>
        <v-card-actions style="height:45px">
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :loading="loading" :disabled="disabled" style="color:white">
                <span v-if="overtimeContext.mode=='Add'">Save</span>
                <span v-if="overtimeContext.mode=='Edit'">Update</span>
            </v-btn>
            <v-btn v-if="overtimeContext.mode!='Edit'" @click="clearForm" :disabled="disabled" >clear</v-btn>
        </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>

import projectsApi from '@/api/projects'
import overtimeApi from '@/api/overtime'
import commonfn from '@/common/functions'

  export default {
    data () {
      return {
        error: false,
        errorMessage: '', 
        loading: false,
        disabled: false,
        error: false,       
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
          counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          } 
        },
        offsetOrPay_list: [
            {offsetOrPay: 1, Description: "For Offset"},
            {offsetOrPay: 2, Description: "For Payroll"}
        ],
        project_list: [],
        projecttask_list: [],        
        overtimeContext: null,
        menuClockStart: false,
        timeClockStart: null,
        menuClockEnd: false,
        timeClockEnd: null,
        breakTime: null,
        chargeableHours: null,
        startDate: new Date().toISOString().substr(0, 10),
        menuStartDate: false,
        endDate: new Date().toISOString().substr(0, 10),
        menuEndDate: false,
        totalHours: null,
        transDate: null,
        menuTransDate: false,
        cutoff: null
      }
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    methods: {      
        allowedDates(val) {
            return (this.$moment(this.cutoff.cutoffStart).format('YYYY-MM-DD') <= this.$moment(val).format('YYYY-MM-DD') &&
                    this.$moment(this.cutoff.cutoffEnd).format('YYYY-MM-DD') >= this.$moment(val).format('YYYY-MM-DD'))
        },
        computeTotalHours() {
            if (this.timeClockStart!=null && this.timeClockEnd!=null && this.overtimeContext.breakTime!=null) {
                var clockStart = this.$moment('1/1/1900 ' + this.timeClockStart)
                var clockEnd = this.$moment('1/1/1900 ' + this.timeClockEnd)

                if (clockStart<clockEnd) {

                var durationTotal = this.$moment.duration(this.$moment(clockEnd).diff(this.$moment(clockStart)))
                var durationChargeable = this.$moment.duration(this.$moment(clockEnd).add(-this.overtimeContext.breakTime,'m').diff(this.$moment(clockStart)))

                this.totalHours = `${durationTotal.hours()}:${durationTotal.minutes()}` 
                this.chargeableHours = `${durationChargeable.hours()}:${durationChargeable.minutes()}`  
             }else{
                //night shift - clockout is on the next day
                var clockEnd = this.$moment('1/2/1900 ' + this.timeClockEnd) //plus one day if night shift

                var durationTotal = this.$moment.duration(this.$moment(clockEnd).diff(this.$moment(clockStart)))
                var durationChargeable = this.$moment.duration(this.$moment(clockEnd).add(-this.overtimeContext.breakTime,'m').diff(this.$moment(clockStart)))

                this.totalHours = `${durationTotal.hours()}:${durationTotal.minutes()}` 
                this.chargeableHours = `${durationChargeable.hours()}:${durationChargeable.minutes()}`  
                }
            }
        },
        formatHours() {
            if (this.overtimeContext.hours!=null) {
                var test = parseFloat(this.overtimeContext.hours).toFixed(2);
                this.overtimeContext.hours = test
            }
        },
        setProjectTasks() {
            var projectTaskDesc = ''
            var projectTasks = this.project_list.filter(x=>{
                return x.projectId == this.overtimeContext.projectId
            })[0] 
            
            if (projectTasks!=undefined) projectTaskDesc = projectTasks.projectTasks
            this.projecttask_list = projectTaskDesc
        },
        closeDialog() {
            this.clearForm()
            this.$emit('update:dialogOvertime', false)
        },
        async setParams(data) {
            if (this.project_list.length==0) await this.getProjects()

            this.overtimeContext = data
            this.cutoff = data.cutoff
        },        
        async addEditOvertime() {         
            if (this.$refs.form.validate()) {
                try {
                    this.loading = true
                    this.disabled = true
                    
                    var data = {
                        overtimeId: 0,
                        transDate: this.transDate,
                        hours: this.overtimeContext.hours,
                        breakTime: this.overtimeContext.breakTime,
                        chargeableHours: this.chargeableHours,
                        offsetOrPay: this.overtimeContext.offsetOrPay,
                        projectId: this.overtimeContext.projectId,
                        projectTaskId: this.overtimeContext.projectTaskId,
                        remarks: this.overtimeContext.remarks,
                        startTime: this.$moment(this.overtimeContext.transDate).format('MM/DD/YYYY') + ' ' + this.timeClockStart,
                        endTime: this.$moment(this.overtimeContext.transDate).format('MM/DD/YYYY') + ' ' + this.timeClockEnd
                    }

                    var response = await overtimeApi.add(data)

                    if (response && response.status == 200) {
                        this.loading = false
                        this.disabled = false                    
                        this.closeDialog()
                        this.$emit('send', '')
                    }
                }
                catch(error) {
                    this.errorMessage = error
                    this.error = true
                }        
            }
        }, 
        async getProjects() {
            try{
                this.loading = true
                this.disabled = true

                const response = await projectsApi.get() 
                if (response && response.status == 200) {                    
                    this.project_list = response.data.items
                }
                
                this.disabled = false
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },   
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
            this.totalHours = null
            this.chargeableHours = null
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        }
    },
    created() {
        this.commonfn = commonfn
    }
  }
</script>